import React from 'react';

const Privacy = () => {
    return (
        <>
            <div className="bg policy-bg">
                <h1>Privacy Policy</h1>
            </div>

            {/* Main Content */}
            <section className="py-8 sm:py-12 px-4 sm:px-10 lg:px-16">
                <div className="max-w-screen-2xl mx-auto">
                    {/* About Description */}
                    <div className="text-justify">
                        <p className="leading-relaxed mb-6 sm:mb-8">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Privacy;
